import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Region, RegionClient, WorkingGroupClient, WorkingGroups } from "../../../../../web-api-client";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-workingGroup-edit',
  templateUrl: './workingGroups-edit.component.html',
  styleUrls: ['./workingGroups-edit.component.scss']
})
export class WorkingGroupEditComponent implements OnInit {


  public onClose = new Subject<boolean>();
  public isLoaded = true;
  public editObject: WorkingGroups;
  public regions: Region[] = [];

  Form: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, private toastr: ToastrService, public client: WorkingGroupClient, public regionClient: RegionClient) { }

  ngOnInit(): void {


    this.isLoaded = false;

    this.regionClient.getList().subscribe((data) => {

      this.regions = data;
      this.initializeForm();
      this.isLoaded = true;
    });
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      regionId: [this.editObject.regionId],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {


      this.editObject.regionId = this.Form.value.regionId;
      this.editObject.title = this.Form.value.title;
      this.editObject.isActive = this.Form.value.isActive;




      this.client.update(this.editObject).subscribe((user) => {

        this.toastr.success("Успешно Редактиране", "Работна Група", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-top-right",
        });

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
